// extracted by mini-css-extract-plugin
export var border = "_s-7";
export var brand = "_s-s";
export var button = "_s-k";
export var center = "_s-9";
export var centered = "_s-5";
export var closeButton = "_s-b";
export var disabledWrapper = "_s-l";
export var error = "_s-o";
export var extraLarge = "_s-4";
export var extraSmall = "_s-1";
export var fill = "_s-h";
export var footer = "_s-g";
export var footerAction = "_s-i";
export var footerButtons = "_s-j";
export var header = "_s-6";
export var headerWithClose = "_s-c";
export var icon = "_s-n";
export var info = "_s-r";
export var inline = "_s-8";
export var large = "_s-3";
export var main = "_s-d";
export var modal = "_s-0";
export var neutral = "_s-t";
export var noPadding = "_s-f";
export var none = "_s-u";
export var scrollable = "_s-e";
export var small = "_s-2";
export var success = "_s-q";
export var tight = "_s-m";
export var titleIcon = "_s-a";
export var warn = "_s-p";